export default __webpack_public_path__ + "static/media/Delivery_Tracking_White.bbf85939.svg";